<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint - Approval </small>
            <span :class="`badge badge-${this.$route.query.action === 'valid' ? 'success' : this.$route.query.action === 'feedback' ? 'info' : 'danger'}`">{{ this.$route.query.action }}</span>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaint-no" v-model="cca.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">CCF Log Date</label>
                <!-- <input type="text" class="form-control" id="reported-date" v-model="cca.reportedDate" disabled> -->
                <flat-pickr class="form-control" id="reported-date" v-model="cca.reportedDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Distributed to Internal</label>
                <flat-pickr class="form-control" id="reported-date" v-model="cca.distributedToInternal" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Complaint Received Date</label>
                <flat-pickr class="form-control" id="reported-date" v-model="cca.receivedDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Customer</label>
                <input type="text" class="form-control" id="customer" v-model="cca.customerName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Brand</label>
                <input type="text" class="form-control" id="brand" v-model="cca.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Product</label>
                <input type="text" class="form-control" id="product" v-model="cca.productName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Plant</label>
                <input type="text" class="form-control" id="container-no" v-model="cca.plantName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Address</label>
                <textarea class="form-control" id="address" v-model="cca.address" rows="2" disabled></textarea>
            </div>
            <div class="form-group col-3">
                <label for="module">PIC</label>
                <input type="text" class="form-control" id="pic" v-model="cca.pic" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" id="email" v-model="cca.email" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Phone</label>
                <input type="text" class="form-control" id="phone" v-model="cca.phone" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">BL Date</label>
                <!-- <input type="text" class="form-control" id="bl-date" v-model="cca.blDate" disabled> -->
                <flat-pickr class="form-control" id="bl-date" v-model="cca.blDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Dispatch Date</label>
                <!-- <input type="text" class="form-control" id="dispatch-date" v-model="cca.dispatchDate" disabled> -->
                <flat-pickr class="form-control" id="dispatch-date" v-model="cca.dispatchDate" disabled></flat-pickr>
            </div>   
            <div class="form-group col-3">
                <label for="module">Container No.</label>
                <input type="text" class="form-control" id="container-no" v-model="cca.containerNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="subject">Packaging</label>
                <input type="text" class="form-control" id="packaging" v-model="cca.packagingName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="cca.dischargePortName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="country" v-model="cca.countryName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Incoterms</label>
                <input type="text" class="form-control" id="model-of-delivery" v-model="cca.modelOfDeliveryName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Conformance Type</label>
                <input type="text" class="form-control" id="conformance-type" v-model="cca.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="complaint-media" v-model="cca.complaintMediaName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Enclosed</label>
                <input type="text" class="form-control" id="enclosed" v-model="cca.enclosedName" disabled>
            </div>
        </div>
         <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="description" v-model="cca.description" rows="3" disabled></textarea>
            </div>
        </div>
        <div class="row">
            <div v-if="this.$route.query.id !== undefined && this.cca.ccSalesAttachment !== '' && !isLoading" class="form-group col-3">
               <a :href="this.cca.ccSalesAttachment" class="badge badge-primary">Download Attachment from Customer</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.cca.ccSalesAttachment === ''" class="form-group col-3">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Customer</a>
            </div>
            <!-- <div v-if="this.$route.query.id !== undefined && this.ccq.ccAreaOwnerAttachment !== ''" class="form-group col-3">
               <a :href="this.ccq.ccAreaOwnerAttachment" class="badge badge-primary">Download Attachment from Quality</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccAreaOwnerAttachment === ''" class="form-group col-3">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Quality</a>
            </div> -->
        </div>
        <div class="row">
            <div class="form-group col-6">
              <label for="owner-member">Owner Area</label>
              <input type="text" class="form-control" id="owner-name" v-model="cca.ownerMemberName" disabled>
            </div>
            <div class="form-group col-6">
              <label for="owner-member">Owner Email</label>
              <input type="text" class="form-control" id="owner-email" v-model="cca.ownerMemberEmail" disabled>
            </div>
        </div>
        History
        <app-log-history :id="this.$route.query.id" :module="'cc'" />
        <br /><br />
        <div class="row">
            <div class="form-group col-6">
              <label for="comment">Comment</label>
              <textarea class="form-control" id="comment" v-model="cca.comment" rows="3"></textarea>
            </div>
        </div>
        <div v-if="isLoading" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <div v-if="isLoading" style="font-weight: bolder;">Submitting your data... Please Wait</div>
        <div v-if="!isLoading">
            <button type="button" class="btn btn-outline-success" @click="approve">Approve <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-danger" @click="decline" style="margin-left: 20px;">Decline <i class="far fa-window-close"></i></button>
            <button type="button" class="btn btn-outline-success" @click="previewcparcc" style="margin-left: 20px;">Print CPAR-CC <i class="fas fa-print"></i></button>
            <button type="button" class="btn btn-outline-success" @click="previewccf" style="margin-left: 20px;">Print CCF <i class="fas fa-print"></i></button>
        </div>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintVerification, customerComplaintVerificationDetail } from '../../models/customerComplaintVerification'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppLogHistory from '../../components/AppLogHistory'
import { mapActions, mapState } from 'vuex'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppLogHistory
    },
    data() {
        return {
          cca: {...customerComplaintVerification, detail: []},
          newDetail: customerComplaintVerificationDetail,
          selectedId: '',
          dtElements: [
            {
              title: 'Question',
              column: 'question',
              type: 'text'
            },
            {
              title: 'Responder',
              column: 'responder',
              type: 'text'
            },
            {
              title: 'Email',
              column: 'email',
              type: 'text'
            },
            {
              title: 'Answer',
              column: 'answer',
              type: 'text'
            },
            {
                title: 'Attachment',
                column: 'attachment',
                type: 'link'
              },
            {
              title: 'Answered At',
              column: 'answeredAt',
              type: 'date'
            },
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const cciApi = api('customer-complaint-approval')
            this.cca = await cciApi.getWithParams(this.$route.query.id)
        }
    },
    computed: {
        ...mapState(['isLoading'])
    },
    methods: {
        ...mapActions(['appLoading']),
        async approve() {
            this.appLoading(true)
            const cciApi = api('customer-complaint-approval')
            if(this.$route.query.id !== undefined) {
                const comment = this.cca.comment
                await cciApi.update({
                    id: this.$route.query.id,
                    action: 'approve',
                    comment: comment,
                    flow: this.$route.query.action,
                    status: this.$route.query.status,
                }, this.$route.query.id)
            }
            this.appLoading(false)
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        async decline() {
            const cciApi = api('customer-complaint-approval')
            if(this.$route.query.id !== undefined) {
                const comment = this.cca.comment
                await cciApi.update({
                    id: this.$route.query.id,
                    action: 'decline',
                    comment: comment,
                    flow: this.$route.query.action,
                    status: this.$route.query.status,
                }, this.$route.query.id)
            }
            this.$router.push({ name: 'customerComplaintInvestigationAnswerSubmitted' })
        },
        selectRow(id) {
          this.selectedId = id
        },
        finishLookup(data) {
            const currentCcs = this.ccv
            this.cca = {
                ...currentCcs,
                ...data
            }
        },
        previewcparcc() {
            // this.$router.push({
            //     name: 'cpar-cc',
            //     query: {
            //         id: this.$route.query.id
            //     }
            // })
            let newTab = this.$router.resolve({name: 'cpar-cc', query: {id: this.$route.query.id}});
            window.open(newTab.href, '_blank');
        },
        previewccf() {
            // this.$router.push({
            //     name: 'ccf',
            //     query: {
            //         id: this.$route.query.id
            //     }
            // })
            let newTab = this.$router.resolve({name: 'ccf', query: {id: this.$route.query.id}});
            window.open(newTab.href, '_blank');
        },
    }
}
</script>